import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";

import state from "./state";
import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

// Modules
import ShippersModule from "./modules/shippers/index";
import PortModule from "./modules/port/index";
import nimasaAgentModule from "./modules/nimasaAgent/index";
import adminModule from "./modules/admin/index"

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  key: "nimasa-dg-web-app"
});

const store = new Vuex.Store({
  modules: {
    shippers: ShippersModule,
    port: PortModule,
    nimasaAgent: nimasaAgentModule,
    admin: adminModule
  },
  state,
  getters,
  actions,
  mutations,
  plugins: [vuexLocal.plugin]
});

export default store;

/**
 * Delete the localstorage entry which the vuex-persist plugin uses to persist vuex upon reload
 */
export function resetLocalStorage() {
  localStorage.removeItem("nimasa-dg-web-app");
}
